import { blueparrottEcomDomains, jabraEcomDomains } from '../constants';
import { getSiteContext } from './get-site-context';
export var getEcomDomains = function (siteContext) {
    if (siteContext === void 0) { siteContext = getSiteContext(); }
    switch (siteContext) {
        case "blueparrott" /* SiteContext.Blueparrott */:
            return blueparrottEcomDomains;
        case "jabra" /* SiteContext.Jabra */:
        default:
            return jabraEcomDomains;
    }
};
